// removed by extract-text-webpack-plugin
module.exports = {"ServiceDetails":"_3EaPiSKiyeDSbTguBRR9wZ","contentWrapper":"_11roMg9fsjZFNUVcj0npXJ","image":"_324V1_6ivCohdJzp57l-2m","heading":"_2HskXGB-eRdh-JRDtCXovK","underlining":"_7Fptft251jVCWzVAjCbFc","underlining--primary-color":"_2QJ1KWziz8GR18MxEJkfym","underlining--secondary-color":"_2VWBYPXIFdqJ3bauvtCgsu","text":"_2-LMRX_IweUE8oDZewA_62","listItem":"_1YScBa4kVFyEfjetBQs2H2","checkbox":"QZ_1x1aSInEXZmEzbbkdy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ServiceDetails/ServiceDetails.stylesheet.css
// module id = 234
// module chunks = 0